const { logError } = require('../logger');
const BattleCalc = require('../BattleCalc');

const UseAbility = function ({ actor, abilityHandle, staticTarget, stance, altNode }) {
  this.query = (target) => {
    try {
      const victim = target || staticTarget;

      if (!victim) {
        return null;
      }

      if (!BattleCalc.unitCanUseAbility(actor, abilityHandle, victim)) {
        return altNode ? altNode.query(victim) : null;
      }

      return {
        actorId: actor.uid,
        abilityHandle,
        victimId: victim.uid,
        stance,
      };
    } catch (err) {
      logError(err, {
        module: 'UseAbility',
        func: 'query',
        actor,
        abilityHandle,
        staticTarget,
      });
    }
  };
};
module.exports = UseAbility;
